var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.prefixCls + "-timepicker")
  }, [_c('n3-input', {
    attrs: {
      "width": _vm.width,
      "name": _vm.name,
      "rules": _vm.rules,
      "placeholder": _vm.placeholder,
      "custom-validate": _vm.customValidate,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "show-clean": true,
      "icon": "clock-o"
    },
    on: {
      "clean": _vm.clean
    },
    nativeOn: {
      "click": function($event) {
        _vm.inputClick($event)
      }
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }, {
      name: "n3-position",
      rawName: "v-n3-position",
      value: (_vm.show),
      expression: "show"
    }],
    class: (_vm.prefixCls + "-timepicker-popup")
  }, [(_vm.hour) ? _c('div', {
    class: (_vm.prefixCls + "-timepicker-slider-sin-wrap"),
    attrs: {
      "data-role": "hour"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getL('hour')))]), _vm._v(" "), _c('n3-slider', {
    class: (_vm.prefixCls + "-timepicker-slider"),
    attrs: {
      "orientation": "vertical",
      "max": _vm.hourRange[1],
      "min": _vm.hourRange[0]
    },
    model: {
      value: (_vm.time.hour),
      callback: function($$v) {
        _vm.time.hour = $$v
      },
      expression: "time.hour"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.minute) ? _c('div', {
    class: (_vm.prefixCls + "-timepicker-slider-sin-wrap"),
    attrs: {
      "data-role": "minute"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getL('minute')))]), _vm._v(" "), _c('n3-slider', {
    class: (_vm.prefixCls + "-timepicker-slider"),
    attrs: {
      "orientation": "vertical",
      "max": _vm.minuteRange[1],
      "min": _vm.minuteRange[0]
    },
    model: {
      value: (_vm.time.minute),
      callback: function($$v) {
        _vm.time.minute = $$v
      },
      expression: "time.minute"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.second) ? _c('div', {
    class: (_vm.prefixCls + "-timepicker-slider-sin-wrap"),
    attrs: {
      "data-role": "second"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getL('second')))]), _vm._v(" "), _c('n3-slider', {
    class: (_vm.prefixCls + "-timepicker-slider"),
    attrs: {
      "orientation": "vertical",
      "max": _vm.secondRange[1],
      "min": _vm.secondRange[0]
    },
    model: {
      value: (_vm.time.second),
      callback: function($$v) {
        _vm.time.second = $$v
      },
      expression: "time.second"
    }
  })], 1) : _vm._e()])])], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-dc7edc8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc7edc8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Timepicker/n3Timepicker.vue
// module id = 658
// module chunks = 0 1